import React, { useState, Fragment } from "react"
import Lightbox from "react-image-lightbox"
import "react-image-lightbox/style.css"

import pcs from "../../images/photos-coming-soon.jpg"

import "./index.scss"

const ImageGallery = ({ images }) => {
  const [imageIndex, setImageIndex] = useState(0)
  const [isOpen, setIsOpen] = useState(false)

  if (images) {
    const listImages = images.map((image, index) => {
      return (
        <Fragment key={image.id}>
          {index < 1 ? (
            <div className="col-12 gallery-image-main-container">
              <img
                src={images[index]}
                className="gallery-image-main"
                alt=""
                onClick={() => {
                  setIsOpen(true)
                  setImageIndex(index)
                }}
                role="presentation"
              />
            </div>
          ) : (
            <div className="col-3 col-md-3 col-lg-3 col-xl-3 text-center gallery-image-thumbnail-container">
              <img
                src={images[index]}
                className="gallery-image-thumbnail"
                alt=""
                onClick={() => {
                  setIsOpen(true)
                  setImageIndex(index)
                }}
                role="presentation"
              />
            </div>
          )}
        </Fragment>
      )
    })

    return (
      <div className="row">
        {listImages}
        {isOpen && (
          <Lightbox
            mainSrc={images[imageIndex]}
            nextSrc={images[(imageIndex + 1) % images.length]}
            prevSrc={images[(imageIndex + images.length - 1) % images.length]}
            onCloseRequest={() => setIsOpen(false)}
            onMovePrevRequest={() => setImageIndex((imageIndex + images.length - 1) % images.length)}
            onMoveNextRequest={() => setImageIndex((imageIndex + 1) % images.length)}
          />
        )}
      </div>
    )
  } else {
    return (
      <div className="row">
        <div className="col-12 gallery-image-main-container">
          <img
            src={pcs}
            className="gallery-image-main"
            alt="Photos Coming Soon"
          />
        </div>
      </div>
    )
  }
}

export default ImageGallery
